import React from 'react'
import MovimentoEstoqueFormPageContainer from './MovimentoEstoqueFormPageContainer'

export class MovimentoEstoqueFormPage extends React.Component {
  render() {
    return <MovimentoEstoqueFormPageContainer {...this.props} />
  }
}
